import styled from 'styled-components';
import FormControl from './components/FormControl';

const Form = styled.form``;

Form.Control = FormControl;

/** @component */
export default Form;
